const addStock = (state = [], action) => {
    let exist = false
    let entry = [...state].find(x => x.articleType == action.articleType)
    //console.log([...state].find(x => x.articleEntry == action.articleEntry && x.sizeEntry == action.sizeEntry))
    switch (action.type) {
        case 'ADD_STOCK':
            console.log("ArticleSysId")
            console.log(action.articleSysId)
            console.log(action)
            if (entry != null) {
                exist = true
            }
            if (!exist) {
                //no ArticleType found; create new
                return [
                    ...state,
                    {
                        articleType: action.articleType,
                        articleEntries:
                            [{
                                articleEntry: action.articleEntry,
                                articleSysId: action.articleSysId,
                                sizeEntries:
                                    [{
                                        SizeValue: action.sizeEntry,
                                        Amount: action.numberInput,
                                    }],
                                articleImage: action.image
                            }],
                        id: action.id
                    }
                ]
            } else {
                let entryIndex = entry.articleEntries.findIndex(x => x.articleSysId == action.articleSysId)
                if (entryIndex != null && entryIndex != -1) {
                    //no SizeEntry found; add sizeEntry for articleEntry
                    console.log("ArticleEntry: " + entryIndex)
                    let typeIndex = state.findIndex(x => x.articleType == action.articleType);
                    let addStock = [...state];
                    let articleEntries = [...addStock[typeIndex].articleEntries]

                    let sizeIndex = articleEntries[entryIndex].sizeEntries.findIndex(x => x.size == action.sizeEntry)
                    if (sizeIndex != null && sizeIndex != -1) {
                        //sizeEntry found, only add to amount
                        let sizeEntries = [...articleEntries[entryIndex].sizeEntries]
                        console.log("SizeIndex: " + sizeIndex)
                        let amount = [...sizeEntries][sizeIndex].Amount
                        console.log("Amount: " + amount)
                        let newAmount = parseInt(amount) + parseInt(action.numberInput)

                        sizeEntries[sizeIndex] =
                        {
                            SizeValue: action.sizeEntry,
                            Amount: newAmount
                        }

                        articleEntries[entryIndex] = {
                            ...articleEntries[entryIndex],
                            sizeEntries: sizeEntries
                        }

                        addStock[typeIndex] = {
                            ...addStock[typeIndex],
                            articleEntries: articleEntries
                        }

                        return [...addStock]
                    }

                    /////
                    let sizeEntries = [...articleEntries[entryIndex].sizeEntries]
                    console.log("SizeEntries :" + sizeEntries)
                    sizeEntries = [
                        ...sizeEntries,
                        {
                            SizeValue: action.sizeEntry,
                            Amount: action.numberInput,
                        }
                    ]

                    articleEntries[entryIndex] = {
                        ...articleEntries[entryIndex],
                        sizeEntries: sizeEntries
                    }

                    addStock[typeIndex] = {
                        ...addStock[typeIndex],
                        articleEntries: articleEntries
                    }

                    return [...addStock]


                } else {
                    //no ArticleEntry found; add ArticleEntry for ArticleType
                    let typeIndex = state.findIndex(x => x.articleType == action.articleType);
                    let addStock = [...state];
                    let articleEntries = [...addStock[typeIndex].articleEntries]
                    articleEntries = [
                        ...articleEntries,
                        {
                            articleEntry: action.articleEntry,
                            articleSysId: action.articleSysId,
                            sizeEntries:
                                [{
                                    SizeValue: action.sizeEntry,
                                    Amount: action.numberInput,
                                }],
                            articleImage: action.image
                        }
                    ]
                    addStock[typeIndex] = {
                        ...addStock[typeIndex],
                        articleEntries: articleEntries
                    }

                    return [
                        ...addStock
                    ]
                }
            }

        case 'RESET_ADD_STOCK':
            return state = []

        default:
            return state
    }
}

export default addStock
